import { Link } from "react-router-dom";

const ThanksComponent = () => {

  return (
    <div>
      <div className="thanks-component">
        <div>Your AC Service Is Confirmed</div>
        <span>Our expert will contact you shortly</span>
        <Link onClick={() =>  window.history.back()}>Go back</Link>
        <br />
        {/* <Link to="tel:+919220407009" target="_blank"><i className="fa-solid fa-phone"></i> Book By Call</Link> */}
      </div>
    </div>
  );
};

export default ThanksComponent;
